export default "__VITE_ASSET__CKitJokb__"